import { render, staticRenderFns } from "./JournalEntryCommunicationTypeIcon.vue?vue&type=template&id=f71ccf6c"
import script from "./JournalEntryCommunicationTypeIcon.vue?vue&type=script&lang=ts"
export * from "./JournalEntryCommunicationTypeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports